import { createSlice } from '@reduxjs/toolkit';

import { apiReducerBuilder } from 'utils';

import { RequestStatus } from 'utils/constants';

import { getAML, getKYC, sendQuiz } from './actions';

const initialState = {
	status: RequestStatus.PENDING,
	kyc: {} as any,
	aml: {} as any,
};

const questionnaireSlice = createSlice({
	name: 'questionnaireS',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		apiReducerBuilder(builder, getKYC, (state, action) => {
			const { meta, payload } = action;
			state.status = meta.requestStatus;

			state.kyc = payload;
		});

		apiReducerBuilder(builder, getAML, (state, action) => {
			const { meta, payload } = action;
			state.status = meta.requestStatus;

			state.aml = payload;
		});

		apiReducerBuilder(builder, sendQuiz, (state, action) => {
			const { meta } = action;
			state.status = meta.requestStatus;
		});
	},
});

export default questionnaireSlice.reducer;
